import { SurveyState } from '../data/gql-gen/dashboard/graphql'
import { useProjectData } from '../modules/Project/Project.hooks'
import { useSurveyId } from './useSurveyId'

/**
 * Whether the viewed survey's audience/fieldwork settings are read-only.
 * Strictly per market: a survey locks once it has left Draft. In a
 * multi-market project the base/master market follows the same rule —
 * launching one market must not freeze another market's audience. The shared
 * master questionnaire has a separate project-wide lock (isProjectInProgress
 * in MultiMarket/markets.utils.ts), which is not this hook's concern.
 */
export const useIsAudienceReadOnly = () => {
  const surveyId = useSurveyId()
  const { project, loading } = useProjectData()

  const survey = project?.surveys.find((s) => s.surveyId === surveyId)

  // No project data yet — assume read-only so queries don't run prematurely.
  const isReadOnly = !project
    ? true
    : survey
      ? survey.state !== SurveyState.Draft
      : false

  return {
    isReadOnly,
    loading
  }
}
